import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { FadeView } from '../../../FadeView';

// ─────────────────────────────────────────────────────────────────────────────

export const QuantityStepperFloatingContainer = (props: Props) => {
  return (
    <FadeView
      show={props.isShown}
      duration={theme.transitions.short}
      style={styles.outerContainer}
    >
      <View style={styles.container}>{props.children}</View>
    </FadeView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTAINER_PADDING = theme.spacing['1'];
const CONTAINER_MIN_WIDTH = 154;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    position: 'absolute',
    top: -CONTAINER_PADDING,
    right: -CONTAINER_PADDING,
    zIndex: theme.zIndex.dropdown,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: CONTAINER_MIN_WIDTH,
    backgroundColor: theme.colors.WHITE,
    borderRadius: 30,
    padding: CONTAINER_PADDING,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  isShown: boolean;
}>;
